import { cloneDeep } from 'lodash';
import { type } from '../constants/manageNumbersConstant'
import { ManageNumbersReducer } from '../models/manageNumbers.interface';

const initialState: ManageNumbersReducer = {
    manageNumbersData: [],
    manageNumbersLoading: true,
    manageNumbersError: false,
    manageNumbersErrorMsg: '',
    numbersTotal: -1,
    currentTotal: -1,
    initialLoading: true,
    paginationLoading: false,
    filterLoading: false,
    currency: '',
    timeStamp: undefined,
}

const isLatestAction = (state: ManageNumbersReducer, data: any) => {
    return data.timeStamp >= state.timeStamp;
}

const manageNumbersReducer = (state: ManageNumbersReducer = initialState, action: any): ManageNumbersReducer => {
    switch (action.type) {
        case type.MANAGE_NUMBERS_LOADING:
            return {
                ...state,
                manageNumbersLoading: true,
                manageNumbersError: false
            }
        case type.MANAGE_NUMBERS_SUCCESS:
            return {
                ...state,
                manageNumbersLoading: false,
                manageNumbersError: false,
                initialLoading: false,
                filterLoading: false,
                manageNumbersData: action.payload.res.data,
                numbersTotal: action.payload.res.total,
                currentTotal: action.payload.res.total,
                currency: action.payload.res.currency
            }
        case type.MANAGE_NUMBERS_FAILED:
            return {
                ...state,
                manageNumbersLoading: false,
                filterLoading: false,
                manageNumbersError: true,
                manageNumbersErrorMsg: action.payload.error
            }

        case type.MANAGE_NUMBERS_PAGINATE_SUCCESS:
            let previousData = cloneDeep(state.manageNumbersData)
            let newData = cloneDeep(action.payload.res.data)
            const data = [...previousData, ...newData]
            return {
                ...state,
                manageNumbersLoading: false,
                manageNumbersError: true,
                manageNumbersData: data,
                currentTotal: action.payload.res.total,
                paginationLoading: false
            }
        case type.MANAGE_NUMBERS_PAGINATE_LOADING:
            return {
                ...state,
                paginationLoading: true,
            }
        case type.MANAGE_NUMBERS_FILTER_LOADING:
            return {
                ...state,
                filterLoading: true
            }
        case type.MANAGE_NUMBERS_FILTER_SUCCESS:
            if (state.timeStamp) {
                if (isLatestAction(state, action.payload)) {
                    return {
                        ...state,
                        filterLoading: false,
                        manageNumbersLoading: false,
                        manageNumbersData: [...action.payload.res.data],
                        currentTotal: action.payload.res.total,
                        // timeStamp: undefined,
                    }
                } else {
                    return state;
                }
            }
            return state;
            // return {
            //     ...state,
            //     filterLoading: false,
            //     manageNumbersLoading: false,
            //     manageNumbersData: [...action.payload.res.data],
            //     currentTotal: action.payload.res.total,
            // }

        case type.MANAGE_NUMBERS_RESET:
            return initialState
        case type.SET_TIMESTAMP:
            return {
                ...state,
                timeStamp: action.payload.timeStamp
            }

        default:
            return state;
    }
}

export default manageNumbersReducer;